import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // api:'https://api.port56.net'
    api: "http://localhost:9000"
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
